import React from "react";
import GoToPage from "./goToPage";
const GroupsMobileTile = (props) => {
  const {
    ico,
    title,
    subTile,
    linkPage,
    linkSide,
    linkName,
    linkFontsize,
    linkTextColor,
    linkBorderType,
    linkBorderColor,
    linkIconSize,
    linkIconColor,
    linkIconMargin,
  } = props;
  return (
    <div className="pt-5 pb-14 pl-5 z-10 relative">
      <div className="pb-5">
        <img loading="lazy" src={ico} className="w-14"></img>
        {title}
      </div>
      <div className="mb-5">
         <GoToPage
        page={linkPage}
        side={linkSide}
        name={linkName}
        fontSize={linkFontsize}
        textColor={linkTextColor}
        borderType={linkBorderType}
        borderColor={linkBorderColor}
        iconSize={linkIconSize}
        iconColor={linkIconColor}
        iconMargin={linkIconMargin}
      ></GoToPage>  
      </div>
     
    </div>
  );
};

export default GroupsMobileTile;
